const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = 336;
const DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;
export {
  DAY_MARGIN,
  DAY_SIZE,
  DIALOG_WIDTH,
  DIGITAL_CLOCK_VIEW_HEIGHT,
  MAX_CALENDAR_HEIGHT,
  MULTI_SECTION_CLOCK_SECTION_WIDTH,
  VIEW_HEIGHT
};
//# sourceMappingURL=dimensions.es.js.map
